/** Ödül Öneri — konular ve RTDB kökü (bölümler RTDB config/departments’tan gelir) */

export const ODUL_ONERI_TOPICS = [
  'İş Sağlığı ve Güvenliği (İSG)',
  'Üretim Süreçlerinin İyileştirilmesi (Zaman Tasarrufu)',
  'Kalite Artışı & Hurda Azaltma & Hata Önleme',
  'Ekipman & Makine Verimliliği (OEE)',
  'İş Kolaylaştırma / Ergonomi',
  'Enerji Tasarrufu ve Verimlilik',
  'Maliyet Azaltma Önerileri',
  'Çevre Koruma & Sürdürülebilirlik',
  'İnovasyon ve Ürün Geliştirme',
  'Saha Düzeni & Görsellik (5S)',
  'Diğer',
]

export const ODUL_ONERI_RTDB_ROOT = 'odul-sureci'
